import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/authentication/auth.service';
import { Shell } from 'src/app/shell/shell.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

interface HomeCard {
  title: string;
  icon: string;
  img: string;
  route?: string;
  roles?: string[];
}

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
})
export class IndexComponent implements OnInit {

    private destroy$ = new Subject<void>();
    private isLoadingNavData: boolean = false;
  cards: HomeCard[] = [];

  visibleCards: HomeCard[] = [];

  constructor(public authService: AuthService,
      private service: Shell,) { }

  ngOnInit() {
    const userRoles = this.authService.roles;
    const isAdmin = this.authService.isAdmin;

    if (isAdmin && !userRoles.includes('Admin')) {
      userRoles.push('Admin');
    }
    console.log(userRoles);

    this.visibleCards = this.cards.filter(card =>
      !card.roles || card.roles.some(role => userRoles.includes(role))
    );

    this.service.getmenu(this.authService.authorizationHeaderValue)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoadingNavData = false;
        })
      )
      .subscribe((result: any) => {
        if (result && result.length > 0) {
          const foundCards: HomeCard[] = [];
          for (const parent of result) {
            if (parent.Submenu && Array.isArray(parent.Submenu)) {
              for (const sub of parent.Submenu) {
                if(sub.Icon !== null && sub.Icon !== undefined){
                  foundCards.push({
                    title: sub.Title,
                    icon: sub.Icon || 'apps',
                    img: '',
                    route: sub.Route
                  });
                }
              }
            }
          }
          this.cards = foundCards;
          this.visibleCards = this.cards;
        }
      }, error => {
        console.error('Error al cargar el menú:', error);
        // En caso de error, mantener el caché si existe
      });
  }
}
